(function () {

  window.initFragranceFinderLp = function () {

    var $ = window.jQuery;

    if (!$ || typeof $.fn.on !== 'function') {
      console.error('[LP] jQuery is required for initFragranceFinderLp');
      return;
    }

    function bindLoad(fn) {
      var run = function () {
        try {
          fn();
        } catch (e) {
          console.warn(
            '[LP] initFragranceFinderLp bindLoad',
            e
          );
        }
      };

      if (document.readyState === 'complete') {
        run();
      } else {
        $(window).on('load', run);
      }
    }


    function safeTop(target) {
      try {
        var $el = target && target.jquery
          ? target
          : $(target);

        if (!$el || !$el.length) {
          return 0;
        }

        var o = $el.offset();
        return o ? o.top : 0;
      } catch (e) {
        return 0;
      }
    }

    // block1
    (function () {
      try {
        const PRIORITY = [
          'ROSE',
          'SEA',
          'JARDIN',
          'HINOKI',
          'STARS'
        ];

        const MAPPING = {
          Q1: {
            '喜び': {
              ROSE: 0,
              HINOKI: 1,
              SEA: 1,
              STARS: 0,
              JARDIN: 1
            },
            '魅惑': {
              ROSE: 1,
              HINOKI: 0,
              SEA: 0,
              STARS: 1,
              JARDIN: 1
            },
            '愛・ときめき': {
              ROSE: 0,
              HINOKI: 0,
              SEA: 1,
              STARS: 1,
              JARDIN: 1
            },
            '穏やかさ': {
              ROSE: 0,
              HINOKI: 1,
              SEA: 1,
              STARS: 1,
              JARDIN: 0
            },
            'エネルギッシュ': {
              ROSE: 0,
              HINOKI: 1,
              SEA: 1,
              STARS: 0,
              JARDIN: 0
            }
          },

          Q2: {
            '清々しい一日のはじまり​': {
              ROSE: 0,
              HINOKI: 1,
              SEA: 1,
              STARS: 0,
              JARDIN: 1
            },
            'くつろぎの夜': {
              ROSE: 0,
              HINOKI: 0,
              SEA: 1,
              STARS: 1,
              JARDIN: 1
            },
            '心弾むお出かけ前​': {
              ROSE: 1,
              HINOKI: 1,
              SEA: 0,
              STARS: 1,
              JARDIN: 0
            },
            'ロマンティックなひととき': {
              ROSE: 1,
              HINOKI: 0,
              SEA: 0,
              STARS: 1,
              JARDIN: 1
            },
            '友人と楽しむ時間​': {
              ROSE: 1,
              HINOKI: 0,
              SEA: 0,
              STARS: 1,
              JARDIN: 1
            }
          },

          Q3: {
            '開放的な海辺​': {
              ROSE: 0,
              HINOKI: 1,
              SEA: 1,
              STARS: 0,
              JARDIN: 1
            },
            '霧深い森​': {
              ROSE: 0,
              HINOKI: 1,
              SEA: 1,
              STARS: 1,
              JARDIN: 0
            },
            '山の中の隠れ家​': {
              ROSE: 0,
              HINOKI: 1,
              SEA: 0,
              STARS: 1,
              JARDIN: 1
            },
            '花が咲き誇る庭園​': {
              ROSE: 1,
              HINOKI: 0,
              SEA: 0,
              STARS: 0,
              JARDIN: 1
            },
            '洗練された都会​': {
              ROSE: 1,
              HINOKI: 1,
              SEA: 0,
              STARS: 1,
              JARDIN: 0
            }
          }
        };

        const RESULT_URL = {
          ROSE: '/pages/result_desert_of_roses',
          JARDIN: '/pages/result_le_jardin_blanc',
          SEA: '/pages/result_idyllic_sea',
          STARS: '/pages/result_incense_of_stars',
          HINOKI: '/pages/result_hinoki_woodland'
        };

        const RESULT_NAME = {
          ROSE: 'DESERT OF ROSES',
          SEA: 'IDYLLIC SEA',
          JARDIN: 'LE JARDIN BLANC',
          HINOKI: 'HINOKI WOODLAND',
          STARS: 'INCENSE OF STARS'
        };

        function getResult(answers) {
          const scores = {
            ROSE: 0,
            HINOKI: 0,
            SEA: 0,
            STARS: 0,
            JARDIN: 0
          };

          ['Q1', 'Q2', 'Q3'].forEach(function (question) {
            const answer = answers[question];
            const mapping =
              MAPPING[question][answer];
            if (!mapping) {
              console.error(
                'Mappingが見つかりません:',
                question,
                answer
              );
              return;
            }

            Object.keys(mapping).forEach(function (scent) {
              scores[scent] += mapping[scent];
            });
          });

          const maxScore =
            Math.max(...Object.values(scores));

          let candidates =
            Object.keys(scores).filter(function (scent) {
              return scores[scent] === maxScore;
            });

          ['Q3', 'Q2', 'Q1'].forEach(function (question) {
            if (candidates.length <= 1) {
              return;
            }

            const answer = answers[question];
            const mapping = MAPPING[question][answer];

            if (!mapping) {
              return;
            }

            const filtered =
              candidates.filter(function (scent) {
                return mapping[scent] === 1;
              });

            if (filtered.length > 0) {
              candidates = filtered;
            }
          });

          const result =
            PRIORITY.find(function (scent) {
              return candidates.includes(scent);
            });

          return {
            scent: result,
            scores: scores
          };
        }

        function showQuestion(target) {
          $('.binding, .question')
            .removeClass('is-active');

          $(target)
            .addClass('is-active');

          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 10);
        }

        $('.js-start').on('click', function (e) {
          e.preventDefault();
          showQuestion('#Question01');
        });

        $('#Question01 input[name="Q1"]')
          .on('change', function () {
            const answer =
              $('#Question01 input[name="Q1"]:checked')
                .val();

            if (!answer) {
              return;
            }

            showQuestion('#Question02');
          });

        $('#Question02 input[name="Q2"]')
          .on('change', function () {
            const answer =
              $('#Question02 input[name="Q2"]:checked')
                .val();

            if (!answer) {
              return;
            }

            showQuestion('#Question03');
          });

        $('#Question03 input[name="Q3"]')
          .on('change', function () {
            const answers = {
              Q1:
                $('#Question01 input[name="Q1"]:checked')
                  .val(),
              Q2:
                $('#Question02 input[name="Q2"]:checked')
                  .val(),
              Q3:
                $('#Question03 input[name="Q3"]:checked')
                  .val()
            };

            console.log('回答:', answers);

            if (
              !answers.Q1 ||
              !answers.Q2 ||
              !answers.Q3
            ) {

              console.log(
                '回答が不足しています'
              );

              return;

            }

            const result =
              getResult(answers);

            console.log(
              '診断結果:',
              result
            );

            const url =
              RESULT_URL[result.scent];

            console.log(
              '遷移先:',
              url
            );

            if (!url) {
              console.error(
                '結果URLが見つかりません:',
                result.scent
              );
              return;
            }
            window.location.href = url;
          });
      } catch (e) {
        console.warn(
          '[LP] initFragranceFinderLp block 1',
          e
        );
      }
    })();

    // block2
    (function () {
      try {
        $(window).on(
          'load scroll',
          function () {
            var pl =
              $(this).scrollTop();

            if (pl == 0) {
              $('.pagetop')
                .css('display', 'none');
            } else {
              $('.pagetop')
                .css('display', 'block');
            }

            var $cbg =
              $('.cbg');

            if (!$cbg.length) {
              return;
            }

            var menu_pos =
              $cbg.offset().top - 1;

            if (pl >= menu_pos) {
              $('.open-menu-out')
                .addClass('view');
            } else {
              $('.open-menu-out')
                .removeClass('view');
            }
          }
        );

        bindLoad(function () {
          if (location.hash !== '') {
            var targetOffset =
              safeTop($(location.hash));

            $(window)
              .delay(1000)
              .scrollTop(targetOffset);
          }
        });
      } catch (e) {
        console.warn(
          '[LP] initFragranceFinderLp block 2',
          e
        );
      }
    })();

    // inview 動的読込後も表示する
    (function () {
      try {
        var $els =
          $('.inview');

        if (!$els.length) {
          return;
        }

        $els.each(function () {
          var $el =
            $(this);

          if ($el.data('lpInviewBound')) {
            return;
          }

          $el.data(
            'lpInviewBound',
            1
          );

          $el.one(
            'inview',
            function (
              event,
              isInView
            ) {

              if (isInView) {
                $(this)
                  .stop()
                  .animate(
                    {
                      opacity: 1
                    },
                    500
                  );
              }
            }
          );
        });

        $(window).trigger('scroll');
      } catch (e) { }
    })();
  };

  window.destroyMintySparkYuzuLp = function () {
    var $ =
      window.jQuery;

    if (!$) {
      return;
    }

    try {
      $('.slick-initialized')
        .each(function () {
          $(this)
            .slick('unslick');
        });
    } catch (e) { }

    try {
      document
        .querySelectorAll('.swiper')
        .forEach(function (el) {
          if (el.swiper) {
            el.swiper.destroy(
              true,
              true
            );
          }
        });

    } catch (e) { }

    $('.open-modal')
      .off('click');

    $('.pagetop a')
      .off('click');
  };
})();